export default __webpack_public_path__ + "static/media/property_555.a8646d14.png";